<template>
    <div>
        <form @submit.prevent="submit">

            <template v-if="isIdoso">
                <div class="row">
                    <form-select
                        grid="12"
                        label="Possui qualificação profissional?"
                        v-model="remuneracaoAuxilio.idoso.possui_qualificacao"
                        :itens="$root.arrays.pergunta"
                    />
                    <form-select
                        v-model="remuneracaoAuxilio.idoso.desc_profissao"
                        :itens="$root.ocupacoes"
                        label="Qual sua profissão de acordo com a CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES ?"
                        :disabled="
                            remuneracaoAuxilio.idoso.possui_qualificacao == 1
                                ? false
                                : true
                        "
                        ajuda="Se o sistema não localizar os dados pesquisado, o que foi digitado será salvo neste campo após clicar em salvar."
                    />
                    <form-select
                        grid="6"
                        label="Recebe aposentadoria por algum desses motivos:"
                        :itens="$root.arrays.aposentadoria_motivo"
                        v-model="remuneracaoAuxilio.idoso.recebe_aposentadoria"
                    />
                    <form-input
                        grid="6"
                        inputGroup="true"
                        btnText="R$"
                        :type="'number'"
                        label="Valor da Aposentadoria"
                        v-model="remuneracaoAuxilio.idoso.valor_aposentadoria"
                    />
                    <form-select
                        grid="6"
                        label="Recebe algum desses benefícios"
                        :itens="$root.arrays.beneficios"
                        v-model="remuneracaoAuxilio.idoso.recebe_beneficio"
                    />
                    <form-input
                        grid="6"
                        inputGroup="true"
                        btnText="R$"
                        :type="'number'"
                        label="Valor do Benefício"
                        v-model="remuneracaoAuxilio.idoso.valor_beneficio"
                    />
                    <form-select
                        label="A pessoa administra seus recursos financeiros?"
                        :itens="$root.arrays.idoso_pessoa_administra_auxilio"
                        v-model="remuneracaoAuxilio.idoso.recursos_financeiros"
                    />
                    <form-select
                        grid="6"
                        label="É beneficiário de Programa Social?"
                        v-model="remuneracaoAuxilio.idoso.programa_social"
                        :itens="$root.arrays.pergunta"
                    />
                    <form-select 
                        label="Descreva o Programa ou Benefício Social:" 
                        :itens="$root.arrays.programa_social_acolhimento" 
                        v-model="remuneracaoAuxilio.idoso.desc_programa_social" 
                        v-show="mostrarDescProgramaSocialIdoso"
                        :required="true" 
                        :multiple="true"
                        grid="12"
                    />
                </div>
                <div v-for="(programaId, index) in remuneracaoAuxilio.idoso.desc_programa_social" :key="programaId" class="row">
                    <form-input
                        grid="6"
                        type="date"
                        :label="`Data de Início - ${programaNome(programaId)}`"
                        v-model="remuneracaoAuxilio.idoso['data_inicio_' + (index + 1)]"
                    />
                    <form-input
                        grid="6"
                        type="number"
                        :label="`Valor R$ (mês) - ${programaNome(programaId)}`"
                        v-model="remuneracaoAuxilio.idoso['valor_mensal_' + (index + 1)]"
                        step="0.01"
                        min="0"
                    />
                </div>
                <div class="row" v-if="remuneracaoAuxilio.idoso.recursos_financeiros == 2">
                    <label class="col my-3 d-block font-weight-bold">
                        Pessoa que administra ou auxilia na administração dos
                        recursos da pessoa
                    </label>
                    <form-input
                        label="Nome"
                        :required="true"
                        v-model="remuneracaoAuxilio.idoso.pessoa_aux_nome"
                    />
                    <form-input
                        label="Endereço"
                        :required="true"
                        v-model="remuneracaoAuxilio.idoso.pessoa_aux_endereco"
                    />
                    <form-input
                        grid="6"
                        label="Telefone"
                        :required="true"
                        v-model="remuneracaoAuxilio.idoso.pessoa_aux_telefone"
                        v-mask="'(##) # ####-####'"
                    />
                    <form-input
                        grid="6"
                        label="E-mail"
                        :required="true"
                        v-model="remuneracaoAuxilio.idoso.pessoa_aux_email"
                    />
                    <form-select
                        label="Possui procuração ou curatela?"
                        grid="6"
                        :itens="$root.arrays.pergunta"
                        v-model="remuneracaoAuxilio.idoso.pessoa_aux_procuracao"
                    />
                </div>
                <div class="row px-2 d-flex justify-content-end">
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </template>

            <template v-else>
                <div class="row">
                    <div class="col-12">

                        <h3>Pessoas Vinculadas ao Acolhimento:</h3>

                        <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                            <template #cell(nome)="row">
                                <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                    {{ row.item.nome }}
                                </a>
                            </template>
                        </b-table>

                        <div v-if="pessoaSelecionada">

                            <br><br>

                            <h3> Trabalho e Renda de: {{ pessoaSelecionada.nome }}</h3>

                            <div class="row">
                                <form-select
                                    grid="12"
                                    label="Possui qualificação profissional?"
                                    v-model="caractRemuneracaoSelecionada.possui_qualificacao"
                                    :itens="$root.arrays.pergunta"
                                />
                                <form-select
                                    v-model="caractRemuneracaoSelecionada.desc_profissao"
                                    :itens="$root.ocupacoes"
                                    label="Qual sua profissão de acordo com a CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES ?"
                                    :disabled="
                                        caractRemuneracaoSelecionada.possui_qualificacao == 1
                                            ? false
                                            : true
                                    "
                                    ajuda="Se o sistema não localizar os dados pesquisado, o que foi digitado será salvo neste campo após clicar em salvar."
                                />
                                <form-select
                                    grid="6"
                                    label="Recebe aposentadoria por algum desses motivos:"
                                    :itens="$root.arrays.aposentadoria_motivo"
                                    v-model="caractRemuneracaoSelecionada.recebe_aposentadoria"
                                />
                                <form-input
                                    grid="6"
                                    inputGroup="true"
                                    btnText="R$"
                                    :type="'number'"
                                    label="Valor da Aposentadoria"
                                    v-model="caractRemuneracaoSelecionada.valor_aposentadoria"
                                />
                                <form-select
                                    grid="6"
                                    label="Recebe algum desses benefícios"
                                    :itens="$root.arrays.beneficios"
                                    v-model="caractRemuneracaoSelecionada.recebe_beneficio"
                                />
                                <form-input
                                    grid="6"
                                    inputGroup="true"
                                    btnText="R$"
                                    :type="'number'"
                                    label="Valor do Benefício"
                                    v-model="caractRemuneracaoSelecionada.valor_beneficio"
                                />
                                <form-select
                                    label="A pessoa administra seus recursos financeiros?"
                                    :itens="$root.arrays.idoso_pessoa_administra_auxilio"
                                    v-model="caractRemuneracaoSelecionada.recursos_financeiros"
                                />
                                <form-select
                                    grid="6"
                                    label="É beneficiário de Programa Social?"
                                    v-model="caractRemuneracaoSelecionada.programa_social"
                                    :itens="$root.arrays.pergunta"
                                />
                                <form-select 
                                    label="Descreva o Programa ou Benefício Social:" 
                                    :itens="$root.arrays.programa_social_acolhimento" 
                                    v-model="caractRemuneracaoSelecionada.desc_programa_social"
                                    :required="true" 
                                    :multiple="true"
                                    grid="12"
                                    v-show="mostrarDescProgramaSocialPessoa"
                                />
                            </div>
                            <div v-for="(programaId, index) in caractRemuneracaoSelecionada.desc_programa_social" :key="programaId" class="row">
                                <form-input
                                    grid="6"
                                    type="date"
                                    :label="`Data de Início - ${programaNome(programaId)}`"
                                    v-model="caractRemuneracaoSelecionada['data_inicio_' + (index + 1)]"
                                />
                                <form-input
                                    grid="6"
                                    type="number"
                                    :label="`Valor R$ (mês) - ${programaNome(programaId)}`"
                                    v-model="caractRemuneracaoSelecionada['valor_mensal_' + (index + 1)]"
                                    step="0.01"
                                    min="0"
                                />
                            </div>
                            <div class="row" v-if="caractRemuneracaoSelecionada.recursos_financeiros == 2">
                                <label class="col my-3 d-block font-weight-bold">
                                    Pessoa que administra ou auxilia na administração dos
                                    recursos da pessoa
                                </label>
                                <form-input
                                    label="Nome"
                                    :required="true"
                                    v-model="caractRemuneracaoSelecionada.pessoa_aux_nome"
                                />
                                <form-input
                                    label="Endereço"
                                    :required="true"
                                    v-model="caractRemuneracaoSelecionada.pessoa_aux_endereco"
                                />
                                <form-input
                                    grid="6"
                                    label="Telefone"
                                    :required="true"
                                    v-model="caractRemuneracaoSelecionada.pessoa_aux_telefone"
                                    v-mask="'(##) # ####-####'"
                                />
                                <form-input
                                    grid="6"
                                    label="E-mail"
                                    :required="true"
                                    v-model="caractRemuneracaoSelecionada.pessoa_aux_email"
                                />
                                <form-select
                                    label="Possui procuração ou curatela?"
                                    grid="6"
                                    :itens="$root.arrays.pergunta"
                                    v-model="caractRemuneracaoSelecionada.pessoa_aux_procuracao"
                                />
                                <form-input
                                    v-if="caractRemuneracaoSelecionada.pessoa_aux_procuracao == 1"
                                    grid="6"
                                    label="Número do documento:"
                                    :required="true"
                                    v-model="caractRemuneracaoSelecionada.pessoa_aux_numero_doc"
                                />
                            </div>
                            <div class="row px-2 d-flex justify-content-end">
                                <button
                                    class="btn btn-success btn-submit"
                                    data-style="zoom-in"
                                    type="submit"
                                >
                                    <i class="mdi mdi-content-save" />
                                    {{ $t("Salvar") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </form>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            remuneracaoAuxilio: {
                idoso: {
                    auxilio_pessoa: null,
                    pessoa_aux_nome: null,
                    pessoa_aux_endereco: null,
                    pessoa_aux_telefone: null,
                    pessoa_aux_email: null,
                    pessoa_aux_procuracao: null,
                    pessoa_aux_numero_doc: null,
                    possui_qualificacao: null,
                    desc_profissao: null,
                    recebe_aposentadoria: null,
                    valor_aposentadoria: null,
                    recebe_beneficio: null,
                    valor_beneficio: null,
                    recursos_financeiros: null,
                    programa_social: null,
                    desc_programa_social: null,
                    data_inicio_1: null,
                    valor_mensal_1: null,
                    data_inicio_2: null,
                    valor_mensal_2: null,
                    data_inicio_3: null,
                    valor_mensal_3: null,
                    data_inicio_4: null,
                    valor_mensal_4: null,
                    data_inicio_5: null,
                    valor_mensal_5: null,
                    data_inicio_6: null,
                    valor_mensal_6: null,
                },
                pessoasVinculadas: []
            },
            caractRemuneracaoSelecionada: null,
            pessoaReferencia: [],
            pessoaSelecionada: null,
        };
    },
    watch: {
        item: {
            immediate: true,
            handler(newVal) {
                if (newVal.remuneracaoAuxilio) {
                    this.remuneracaoAuxilio.idoso = newVal.remuneracaoAuxilio.idoso
                        ? this.preencherCamposRemuneracao(newVal.remuneracaoAuxilio.idoso)
                        : this.preencherCamposRemuneracao(null);

                    this.remuneracaoAuxilio.pessoasVinculadas = newVal.remuneracaoAuxilio.pessoasVinculadas || [];
                } else {
                    this.remuneracaoAuxilio.idoso = this.preencherCamposRemuneracao(null);
                    this.remuneracaoAuxilio.pessoasVinculadas = [];
                }

                if (newVal.pessoaReferencia) {
                    this.pessoaReferencia = newVal.pessoaReferencia;
                }
            }
        },
        'remuneracaoAuxilio.idoso.programa_social'(novoValor) {
            if (novoValor === 2) {
                this.remuneracaoAuxilio.idoso.desc_programa_social = null;
            }
        },
        'caractRemuneracaoSelecionada.programa_social'(novoValor) {
            if (novoValor === 2) {
                this.caractRemuneracaoSelecionada.desc_programa_social = null;
            }
        },
        'remuneracaoAuxilio.idoso.desc_programa_social'(newVal, oldVal) {
            // Zerando campos para os índices que foram removidos
            for(let i = newVal.length; i < 6; i++) {
                this.remuneracaoAuxilio.idoso['data_inicio_' + (i+1)] = null;
                this.remuneracaoAuxilio.idoso['valor_mensal_' + (i+1)] = null;
            }
        },
        'caractRemuneracaoSelecionada.desc_programa_social'(newVal, oldVal) {
            if (!this.caractRemuneracaoSelecionada) return;
            for(let i = newVal.length; i < 6; i++) {
                this.caractRemuneracaoSelecionada['data_inicio_' + (i+1)] = null;
                this.caractRemuneracaoSelecionada['valor_mensal_' + (i+1)] = null;
            }
        }
    },
    computed: {
        todasPessoas() {
            const pessoaPrincipal = {
                id: 'principal',
                nome: this.item.nome_acolhido,
                idade: this.calcularIdade(this.item.nascimento),
                parentesco: 'Acolhido(a)',
                tipo_cadastro: 'Principal',
            };

            const vinculados = this.pessoaReferencia.filter(
                p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
            );

            return [pessoaPrincipal, ...vinculados];
        },
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
        mostrarDescProgramaSocialIdoso() {
            return this.remuneracaoAuxilio?.idoso?.programa_social === 1;
        },
        mostrarDescProgramaSocialPessoa() {
            return this.caractRemuneracaoSelecionada?.programa_social === 1;
        },
        programasSelecionados() {
            // para idoso ou pessoa vinculada, retorne o array de programas selecionados (ids)
            if (this.isIdoso) {
                return this.remuneracaoAuxilio.idoso.desc_programa_social || [];
            }
            else if (this.caractRemuneracaoSelecionada) {
                return this.caractRemuneracaoSelecionada.desc_programa_social || [];
            }
            return [];
        },
    },
    mounted() {

        if (this.item.remuneracaoAuxilio) {

            this.remuneracaoAuxilio.idoso = this.item.remuneracaoAuxilio?.idoso
                ? this.preencherCamposRemuneracao(this.item.remuneracaoAuxilio.idoso)
                : this.preencherCamposRemuneracao(null);

            this.remuneracaoAuxilio.pessoasVinculadas = this.item.remuneracaoAuxilio?.pessoasVinculadas || [];

        }

        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }
        
    },
    methods: {
        calcularIdade(dataNasc) {
            if (!dataNasc) return null;
            const hoje = new Date();
            const nasc = new Date(dataNasc);
            let idade = hoje.getFullYear() - nasc.getFullYear();
            const m = hoje.getMonth() - nasc.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
                idade--;
            }
            return idade;
        },
        programaNome(id) {
            const prog = this.$root.arrays.programa_social_acolhimento.find(p => p.id == id);
            return prog ? prog.value : id;
        },
        submit() {

            if (this.pessoaSelecionada) {
                if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                    this.remuneracaoAuxilio.idoso = { ...this.caractRemuneracaoSelecionada };
                } else {
                    this.pessoaSelecionada.caracteristica_remuneracao = { ...this.caractRemuneracaoSelecionada };
                }
            }

            this.item.remuneracaoAuxilio = {
                idoso: this.remuneracaoAuxilio.idoso,
                pessoasVinculadas: this.pessoaReferencia
                    .filter(p => p.caracteristica_remuneracao)
                    .map(p => ({
                        ...p.caracteristica_remuneracao,
                        pessoa_referencia_id: p.id,
                    }))
            };

            this.$emit("submit");
        },
        preencherCamposRemuneracao(obj) {
            const campos = [
                            'auxilio_pessoa',
                            'pessoa_aux_nome',
                            'pessoa_aux_endereco',
                            'pessoa_aux_telefone',
                            'pessoa_aux_email',
                            'pessoa_aux_procuracao',
                            'pessoa_aux_numero_doc',
                            'possui_qualificacao',
                            'desc_profissao',
                            'recebe_aposentadoria',
                            'valor_aposentadoria',
                            'recebe_beneficio',
                            'valor_beneficio',
                            'recursos_financeiros',
                            'programa_social',
                            'desc_programa_social',
                            'data_inicio_1',
                            'valor_mensal_1',
                            'data_inicio_2',
                            'valor_mensal_2',
                            'data_inicio_3',
                            'valor_mensal_3',
                            'data_inicio_4',
                            'valor_mensal_4',
                            'data_inicio_5',
                            'valor_mensal_5',
                            'data_inicio_6',
                            'valor_mensal_6'
                        ];

            if (!obj) obj = {};
            campos.forEach(campo => {
                if (obj[campo] === null || obj[campo] === undefined) {
                    obj[campo] = null;
                }
            });

            return obj;
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }
                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },  
        selecionarPessoa(pessoa) {
            this.pessoaSelecionada = pessoa;

            if (pessoa.tipo_cadastro === 'Principal') {

                this.caractRemuneracaoSelecionada = { ...this.remuneracaoAuxilio.idoso };

            }else{

                // Tenta achar os dados de saúde da pessoa selecionada
                const dadosRemuneracao = this.item.remuneracaoAuxilio?.pessoasVinculadas?.find(
                    cs => cs.pessoa_referencia_id === pessoa.id
                );

                // Se existir, usa esses dados para preencher caractEducacaoSelecionada
                this.caractRemuneracaoSelecionada = dadosRemuneracao ? { ...dadosRemuneracao } : {
                    pessoa_referencia_id: pessoa.id,
                    auxilio_pessoa: null,
                    pessoa_aux_nome: null,
                    pessoa_aux_endereco: null,
                    pessoa_aux_telefone: null,
                    pessoa_aux_email: null,
                    pessoa_aux_procuracao: null,
                    pessoa_aux_numero_doc: null,
                    possui_qualificacao: null,
                    desc_profissao: null,
                    recebe_aposentadoria: null,
                    valor_aposentadoria: null,
                    recebe_beneficio: null,
                    valor_beneficio: null,
                    recursos_financeiros: null,
                    programa_social: null,
                    desc_programa_social: null,
                    data_inicio_1: null,
                    valor_mensal_1: null,
                    data_inicio_2: null,
                    valor_mensal_2: null,
                    data_inicio_3: null,
                    valor_mensal_3: null,
                    data_inicio_4: null,
                    valor_mensal_4: null,
                    data_inicio_5: null,
                    valor_mensal_5: null,
                    data_inicio_6: null,
                    valor_mensal_6: null,
                };

            }

        },
    }
};
</script>
